<template>
  <pages-publications-slug-component
    v-if="data"
    :data="data"
    :prev="prev"
    :next="next"
  />
  <shared-page-not-found-component v-else-if="!data" />
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryPublicationEntryBySlug(getPageQuery()) } } ) )

data.value = getFirstObject(data.value?.data)

setHead(data.value, data.value?.coverImage)

// 2
const datePublished = data.value?.datePublished || ''
const title = data.value?.title || ''

const prevQueryOptions = getPagePrevNextQuery({
  filterId: '$lt',
  filterValue: datePublished,
  sortDir: 'desc',
  sortDirSecondary: 'desc',
  filterValueSecondary: title
})
const { data: prev, error: prevError } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryPublicationEntryPrevNextBySlug(prevQueryOptions) } } ) )
prev.value = getFirstObject(prev.value?.data)

const nextQueryOptions = getPagePrevNextQuery({
  filterId: '$gt',
  filterValue: datePublished,
  sortDir: 'asc',
  sortDirSecondary: 'asc',
  filterValueSecondary: title
})
const { data: next } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryPublicationEntryPrevNextBySlug(nextQueryOptions) } } ) )
next.value = getFirstObject(next.value?.data)
</script>
